import React, { Suspense } from 'react';
import { MoveToJianListButton } from '../../components/MoveToJianListButton';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { OaCsvOutputJobList } from './OaCsvOutputJobList';
import { SelectiveCsvOutputJobList } from './SelectiveCsvOutputJobList';
import { ErrorBoundary } from 'react-error-boundary';

export const CsvDownloadList: React.FC = () => {
  return (
    <div className="w-full h-full px-24">
      <MoveToJianListButton />
      <h1 className="text-2xl font-bold text-darkblue_100 mb-4">CSVダウンロード管理</h1>
      <div className="px-4 mt-8">
        <TabGroup className="w-full">
          <TabList className="w-full border-b border-darkblue_70">
            <Tab className="px-4 pt-2 pb-1.5 rounded-t border-t border-x border-darkblue_70 text-sm font-bold text-darkblue_100 aria-selected:text-white aria-selected:bg-darkblue_100">
              国表CSV出力
            </Tab>
            <Tab className="px-4 pt-2 pb-1.5 rounded-t border-t border-x border-darkblue_70 text-sm font-bold text-darkblue_100 aria-selected:text-white aria-selected:bg-darkblue_100">
              CSV選択出力
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <div className="h-[calc(100vh-14rem)] overflow-y-auto px-2 py-6">
                <ErrorBoundary
                  fallback={<div className="text-error">Error:リストの取得に失敗</div>}
                >
                  <Suspense fallback={<div>Loading...</div>}>
                    <OaCsvOutputJobList />
                  </Suspense>
                </ErrorBoundary>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="h-[calc(100vh-14rem)] overflow-y-auto px-2 py-6">
                <ErrorBoundary
                  fallback={<div className="text-error">Error:リストの取得に失敗</div>}
                >
                  <Suspense fallback={<div>Loading...</div>}>
                    <SelectiveCsvOutputJobList />
                  </Suspense>
                </ErrorBoundary>
              </div>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  );
};
